<template>
    <div>
        <v-data-table id="paymentsTable"
                      :headers="headers" :search="searchQuery"
                      :items="dids" :loading="isLoadingDIDs"
                      item-key="did" :pagination.sync="paginationSync"
                      show-summary data-app
        >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <tr>
                    <td>
                        <el-tooltip :content="props.item.country"
                                    effect="dark"
                                    :open-delay="300"
                                    placement="top">
                            <span
                                :class="'flag-icon flag-icon-' + (typeof props.item.country === 'string' ? props.item.country.toLowerCase() : '')"></span>
                        </el-tooltip>
                    </td>
                    <td>{{ props.item.formatted_did }}</td>
                    <td class="hidden-xs-only">{{ props.item.tag }}</td>
                    <td class="hidden-xs-only">
                        <el-tooltip
                            :content="'All inbound calls that are Anonymous (Restricted) will be blocked.'"
                            :open-delay="300"
                            effect="dark"
                            placement="top">
                            <badge type="danger" v-if="props.item.block_anonymous">Block Anonymous</badge>
                        </el-tooltip>
                        <el-tooltip
                            :content="'Inbound recording is enabled on ' + props.item.formatted_did + ' to ' + props.item.recordingemail"
                            :open-delay="300"
                            effect="dark"
                            placement="top">
                            <badge v-if="props.item.recordingemail" type="info">Inbound recording</badge>
                        </el-tooltip>

                    </td>
                    <td class="">
                        <base-button type="primary" class="mr-1" size="sm"
                                     @click="$router.push({ path: `/callflow/${props.item.did}` })">
                            <span class="hidden-xs-only">Call Flow</span>
                            <span class="hidden-sm-and-up"><font-awesome-icon
                                :icon="['fal','route']"></font-awesome-icon></span>
                        </base-button>
                        <base-button type="warning" class="mr-1" size="sm" @click="handleEdit(props.item)">
                            <span class="hidden-xs-only">Edit</span>
                            <span class="hidden-sm-and-up"><font-awesome-icon
                                :icon="['fal','pencil']"></font-awesome-icon></span>
                        </base-button>
                        <el-tooltip
                            :content="'Coming soon!'"
                            :open-delay="300"
                            effect="dark"
                            placement="top">
                            <base-button disabled="disabled" size="sm" type="danger">
                                <span class="hidden-xs-only">Release</span>
                                <span class="hidden-sm-and-up"><font-awesome-icon
                                    :icon="['fal','trash']"></font-awesome-icon></span>
                            </base-button>
                        </el-tooltip>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <NumberSettingsModal :initialNumber="currentNumber" v-if="currentNumber"
                             v-on:update:show="showNumberSettingsModal = $event"
                             :show="showNumberSettingsModal"></NumberSettingsModal>
    </div>
</template>

<script>
    import NumberSettingsModal from "./SettingsModal";
    import Badge from "../../components/Badge";
    import CallflowModal from "./CallflowModal";

    export default {
        name: "PhoneNumbersTable",
        components: {CallflowModal, Badge, NumberSettingsModal},
        computed: {
            dids() {
                return this.$store.getters['did/uniqueDIDs'];
            },
            isLoadingDIDs() {
                return this.$store.getters['did/isLoading'];
            },
        },
        data() {
            return {
                currentNumber: null,
                showNumberSettingsModal: false,
                showCallFlowModal: false,
                rowsperpageitems:
                    [5, 10, 25, 50, 100, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],

                paginationSync: {
                    rowsPerPage: 10,
                },
                propsToSearch: ['country', 'formatted_did', 'tag'],
                searchedData: [],
                searchQuery: '',
                fuseSearch: null,
                loading: [],
                headers: [
                    {
                        text: 'Country',
                        align: 'left',
                        sortable: true,
                        value: 'country'
                    },
                    {text: 'Number', value: 'formatted_did', sortable: true,},
                    {text: 'Name', value: 'tag'},
                    {text: 'Features', value: 'formatted_did'},
                    {text: 'Actions', align: 'right',},
                ],
            };
        },
        methods: {
            handleEdit(number) {
                this.currentNumber = number;
                this.showNumberSettingsModal = true;
            },
        },
        mounted() {
            if (this.$store.getters['did/needUpdate']) {
                this.$store.dispatch('did/loadUniqueDIDs');
            }

            if (this.$store.getters['callflow/needUpdate']) {
                this.$store.dispatch('callflow/loadAll');
            }


        },
    }
</script>
<style>
    .pagination-select,
    .search-input {
        width: 200px;
    }
</style>
